import { render, staticRenderFns } from "./study-team.vue?vue&type=template&id=36f94201&scoped=true&"
import script from "./study-team.vue?vue&type=script&lang=js&"
export * from "./study-team.vue?vue&type=script&lang=js&"
import style0 from "./study-team.vue?vue&type=style&index=0&id=36f94201&scoped=true&lang=scss&"
import style1 from "./study-team.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f94201",
  null
  
)

component.options.__file = "study-team.vue"
export default component.exports